import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {filter, map} from 'rxjs/operators';
import { MatCard, MatCardTitle } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-download-bill',
    templateUrl: './download-bill.component.html',
    styleUrls: ['./download-bill.component.css'],
    imports: [MatCard, MatCardTitle, MatProgressSpinner]
})
export class DownloadBillComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);


  encryptedData: Params;
  apiUrl = environment.apiUrl;
  errTxt: string;
  isLoading = true;
  showLink = false;

  constructor() {
    this.route.params.subscribe( (params) => {
      this.encryptedData = params;
    });
  }

  ngOnInit(): void {
    this.showLink = false;
    this.http.post(this.apiUrl + '/bills/download-bill-ext', this.encryptedData.id, {
      observe: 'response',
      responseType: 'text'
    })
      .pipe(
        filter((res: HttpResponse<string>) => res.ok),
        map((res: HttpResponse<string>) => res.body)
      )
      .subscribe((response: string) => {
        this.isLoading = false;
        const linkSource = 'data:application/pdf;base64,' + response;
        const downloadLink = document.createElement('a');
        const fileName = 'Facture_InExtenso.pdf';

        const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (IS_IOS) {
          document.documentElement.classList.add('ios');
        }

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      }, (error: string) => {
        switch (error) {
          case 'ERR_GET_BILL':
            this.errTxt = 'Problème lors de la génération de la facture. Si le problème persiste, veuillez contacter votre agence';
            break;

          case 'ERR_EXPIRATION':
            this.errTxt = 'La mise à disposition de vos factures directement n’est possible que pour les factures ayant moins de 2 moins d’ancienneté. Pour un historique plus ancien (inférieur à 3 ans), vous avez la possibilité de récupérer ce PDF en vous connectant à votre espace ';
            this.showLink = true;
            break;

          default:
            this.errTxt = 'Une erreur s\'est produite. Si le problème persiste, veuillez contacter votre agence';
            break;
        }
        this.isLoading = false;
      });
  }

}
